import React, { useEffect } from "react";
import "./Splash.scss";
import { Link } from "react-router-dom";

import Appbar from "../../components/Appbar/Appbar";
import Footer from "../../components/Footer/Footer";
import Form from "../../components/Form/Form";
import { useAnalytics } from "../../customHooks/reactGA";

import { Box, Button, Typography } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import TravisHeadshot from "../../assets/Travis_headshot.png";
import iconLight from "../../assets/carp_house_plain.png";
import iconDark from "../../assets/carp-house-plain-dark.png";
import iconWrench from "../../assets/wrench.png";
import iconWrenchDark from "../../assets/wrench_dark.png";
import iconDeadline from "../../assets/deadline.png";
import iconDeadlineDark from "../../assets/deadline_dark.png";
import iconMoney from "../../assets/money.png";
import iconMoneyDark from "../../assets/money_dark.png";
import iconTrust from "../../assets/relationship.png";
import iconTrustDark from "../../assets/relationship_dark.png";

import Commercial from "../../assets/CarpHomes_TV_Commercial_2025.mp4";

import ReactPlayer from "react-player";

const Splash = (props) => {
  const { trackPageView, trackEvent } = useAnalytics();
  const isDark = props.theme.palette.mode === "dark";

  useEffect(() => {
    trackPageView("/");
  }, [trackPageView]);

  const featureTextColor = isDark
    ? props.theme.palette.common.white
    : props.theme.palette.primary.main;

  return (
    <div>
      <Appbar
        colorMode={props.colorMode}
        theme={props.theme}
        mode={props.mode}
      />

      <Box
        component="section"
        className="landing"
        sx={(theme) => ({
          backgroundColor:
            theme.palette.mode === "dark"
              ? theme.palette.primary.dark
              : "#e4e4e4",
          color:
            theme.palette.mode === "dark"
              ? theme.palette.common.white
              : theme.palette.primary.main,
          backgroundImage: `url(${theme.palette.mode === "dark" ? iconDark : iconLight})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "contain",
          px: { xs: 3, md: 7 },
          py: { xs: 6, md: 8 },
        })}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
            alignItems: "center",
            gap: { xs: 5, md: 6 },
            maxWidth: "1350px",
            width: "100%",
            mx: "auto",
          }}
        >
          <Box sx={{ width: "100%", minWidth: 0 }}>
            <Typography
              component="h1"
              className="heading-title l1 heading-title--pop"
              sx={(theme) => ({
                color:
                  theme.palette.mode === "dark"
                    ? theme.palette.common.white
                    : theme.palette.primary.main,
              })}
            >
              Sell your House
              <Box component="span" sx={{ color: "warning.main", ml: "10px" }}>
                Fast
              </Box>
              ,
              <br />
              for
              <Box component="span" sx={{ color: "warning.main", ml: "10px" }}>
                Cash
              </Box>
              ,
              <br /> with
              <Box component="span" sx={{ color: "warning.main", ml: "10px" }}>
                No Hassle
              </Box>
              .
            </Typography>

            <Typography
              component="p"
              className="heading-title l2"
              sx={(theme) => ({
                color:
                  theme.palette.mode === "dark"
                    ? theme.palette.common.white
                    : theme.palette.primary.dark,
                maxWidth: "520px",
              })}
            >
              CarpHomes buys homes directly from homeowners in the Indianapolis
              area, offering speed, cash, and discretion. No commissions, no
              closing costs, no headaches.
            </Typography>

            <Box
              sx={{
                display: "flex",
                gap: 3,
                mt: 3,
                alignItems: "flex-start",
                flexWrap: "wrap",
              }}
            >
              <Box sx={{ minWidth: 120, textAlign: "center" }}>
                <Typography
                  fontSize="2rem"
                  fontWeight={700}
                  color="warning.main"
                >
                  5★
                </Typography>
                <Typography fontSize="0.95rem" color={featureTextColor}>
                  5 stars on Google
                </Typography>
              </Box>

              <Box sx={{ minWidth: 140, textAlign: "center" }}>
                <Typography
                  fontSize="2rem"
                  fontWeight={700}
                  color="warning.main"
                >
                  A+
                </Typography>
                <Typography fontSize="0.95rem" color={featureTextColor}>
                  A+ rating on BBB
                </Typography>
              </Box>

              <Box sx={{ minWidth: 160, textAlign: "center" }}>
                <Typography
                  fontSize="2rem"
                  fontWeight={700}
                  color="warning.main"
                >
                  60+
                </Typography>
                <Typography fontSize="0.95rem" color={featureTextColor}>
                  Avg. transactions / year
                </Typography>
              </Box>

              <Box sx={{ ml: 2 }}>
                <Typography
                  textAlign="center"
                  fontFamily="latoBold"
                  sx={{ color: "warning.main" }}
                >
                  As seen on WISH-TV!
                </Typography>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              width: "100%",
              minWidth: 0,
              display: "flex",
            }}
          >
            <Box
              sx={(theme) => ({
                width: "100%",
                p: { xs: 2.5, md: 4 },
                borderRadius: "24px",
                backgroundColor:
                  theme.palette.mode === "dark"
                    ? "rgba(0, 0, 0, 0.25)"
                    : "rgba(255, 255, 255, 0.72)",
                boxShadow:
                  theme.palette.mode === "dark"
                    ? "0 20px 45px rgba(0, 0, 0, 0.25)"
                    : "0 20px 45px rgba(0, 0, 0, 0.12)",
                backdropFilter: "blur(4px)",
              })}
            >
              <Typography
                sx={(theme) => ({
                  color:
                    theme.palette.mode === "dark"
                      ? theme.palette.common.white
                      : theme.palette.primary.main,
                  fontSize: { xs: "1.5rem", md: "2rem" },
                  fontFamily: "karla",
                  mb: 2,
                  textAlign: "center",
                })}
              >
                Get Your Free, No-Obligation Cash Offer Today
              </Typography>

              <Form theme={props.theme} />
            </Box>
          </Box>
        </Box>
      </Box>

      <Box
        component="section"
        className="offerings-container"
        sx={(theme) => ({
          backgroundColor:
            theme.palette.mode === "dark"
              ? theme.palette.primary.dark
              : "#e4e4e4",
          px: { xs: 3, md: 7 },
          py: 4,
          display: "flex",
          justifyContent: "center",
        })}
      >
        <Box className="content-wrapper">
          <Box
            display="flex"
            justifyContent="center"
            flexDirection="row"
            flexWrap="wrap"
          >
            {[
              {
                title: "Fast Closings",
                body: "Sell your house in as little as 7 days.",
                alt: "fast closings icon",
                icon: isDark ? iconDeadline : iconDeadlineDark,
                className: "feature-ico adj-deadline",
                height: "75px",
              },
              {
                title: "No Repairs Needed",
                body: "We buy houses as-is, no matter the condition.",
                alt: "no repairs needed icon",
                icon: isDark ? iconWrench : iconWrenchDark,
                className: "feature-ico",
                height: "75px",
              },
              {
                title: "Cash Offers",
                body: "Avoid financing delays. Get paid in cash at closing.",
                alt: "money icon",
                icon: isDark ? iconMoney : iconMoneyDark,
                className: "feature-ico adj-money",
                height: "58px",
              },
              {
                title: "Local and Trustworthy",
                body: "As a local Indy business, we offer in-person service.",
                alt: "trust icon",
                icon: isDark ? iconTrust : iconTrustDark,
                className: "feature-ico",
                height: "75px",
              },
            ].map((item) => (
              <Box
                key={item.title}
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                textAlign="center"
                sx={{ flex: "1 1 220px" }}
                p={2}
              >
                <Box mb={item.title === "Cash Offers" ? 2 : 0}>
                  <img
                    className={item.className}
                    alt={item.alt}
                    src={item.icon}
                    style={{ height: item.height, width: "auto" }}
                  />
                </Box>

                <Typography
                  fontSize="1.25rem"
                  fontWeight={600}
                  color="warning.main"
                >
                  {item.title}
                </Typography>

                <Typography fontSize="1rem" color={featureTextColor}>
                  {item.body}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>

      <Box
        component="section"
        sx={(theme) => ({
          backgroundColor:
            theme.palette.mode === "dark"
              ? theme.palette.primary.dark
              : theme.palette.common.white,
        })}
      >
        <Box className="content-wrapper">
          <Box component="section" className="welcome-container">
            <Box sx={{ width: "100%", mx: "auto" }}>
              <Typography
                className="welcome-h1 heading"
                sx={(theme) => ({
                  fontFamily: "karla",
                  color:
                    theme.palette.mode === "dark"
                      ? theme.palette.common.white
                      : theme.palette.primary.main,
                  mb: "-0.15em",
                })}
              >
                Sell Your Indiana Home Fast and Hassle-Free with CarpHomes
              </Typography>

              <Typography
                className="welcome-h2 heading"
                sx={{
                  fontSize: "1.65rem",
                  lineHeight: "2.25rem",
                  color: "warning.main",
                  width: { xs: "100%", md: "75%" },
                  mt: 3,
                }}
              >
                At CarpHomes, we make selling your property in central Indiana
                as easy as possible.
              </Typography>

              <Box
                className="wc-adj"
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                  flexDirection: { xs: "column", md: "row" },
                  gap: 4,
                  mt: 5,
                }}
              >
                <Box>
                  {[
                    "As a local business, born and raised right here in Indiana, we understand the community and the unique challenges homeowners face. Whether your home is move-in ready or needs significant repairs, we are ready to buy it.",
                    "We specialize in offering cash purchases and can close quickly—often in as little as 7 days. Best of all, you’ll pay no realtor commissions or closing costs when selling to us.",
                    "We also provide the privacy and flexibility that comes with selling off-market. No public listings, no open houses, and no lengthy negotiations. Because we’re local, you can count on a personal, one-on-one experience. A member of our team will meet with you in person, understand your needs, and guide you through every step of the process.",
                  ].map((text) => (
                    <Typography
                      key={text}
                      sx={(theme) => ({
                        fontSize: "1.25rem",
                        lineHeight: "2.25rem",
                        color:
                          theme.palette.mode === "dark"
                            ? theme.palette.common.white
                            : theme.palette.primary.main,
                        mb: 3,
                      })}
                    >
                      {text}
                    </Typography>
                  ))}
                </Box>

                <Box p={2.5} mt={5}>
                  <Box
                    sx={(theme) => ({
                      backgroundColor:
                        theme.palette.mode === "dark"
                          ? theme.palette.secondary.main
                          : theme.palette.warning.main,
                      height: "300px",
                      width: "300px",
                      borderRadius: "50%",
                      overflow: "hidden",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "end",
                    })}
                  >
                    <img
                      src={TravisHeadshot}
                      height="275px"
                      width="auto"
                      style={{ marginLeft: "0.75em" }}
                      alt="Travis Carpenter Headshot"
                    />
                  </Box>

                  <Typography
                    textAlign="center"
                    fontFamily="latoBold"
                    mt={2.5}
                    sx={(theme) => ({
                      color:
                        theme.palette.mode === "dark"
                          ? theme.palette.secondary.main
                          : theme.palette.warning.main,
                    })}
                  >
                    Travis Carpenter, CEO
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Box mt={10}>
              <ReactPlayer url={Commercial} controls width="100%" />

              <Typography
                textAlign="center"
                mt={1}
                fontFamily="latoBold"
                sx={(theme) => ({
                  color:
                    theme.palette.mode === "dark"
                      ? theme.palette.secondary.main
                      : theme.palette.warning.main,
                })}
              >
                As seen on WISH-TV!
              </Typography>
            </Box>

            <Box sx={{ mt: "6em" }}>
              <Button
                variant="outlined"
                color="warning"
                sx={{ px: "25px", py: "15px" }}
              >
                <Link className="link-item" to="/about">
                  <Typography
                    sx={(theme) => ({
                      color:
                        theme.palette.mode === "dark"
                          ? theme.palette.common.white
                          : theme.palette.primary.main,
                    })}
                  >
                    About Us
                  </Typography>
                </Link>
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box
        component="section"
        className="promise-container"
        sx={(theme) => ({
          backgroundColor:
            theme.palette.mode === "dark"
              ? theme.palette.primary.main
              : "#e4e4e4",
          px: { xs: 3, md: 7 },
          py: 5,
        })}
      >
        <Box>
          <Typography
            textAlign="center"
            fontSize="2.25rem"
            pt="4rem"
            sx={(theme) => ({
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.common.white
                  : theme.palette.primary.main,
            })}
          >
            Our Promise
          </Typography>

          <Typography
            textAlign="center"
            fontSize="1.5rem"
            sx={(theme) => ({
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.common.white
                  : theme.palette.primary.main,
            })}
          >
            Why CarpHomes Stands Out
          </Typography>
        </Box>

        <Box className="content-wrapper">
          <Box mt={10} mb={10}>
            {[
              [
                "We're Invested in Our Community",
                "Most homes we purchase are renovated and restored to improve the neighborhood.",
              ],
              [
                "Personalized Customer Service",
                "We meet you face-to-face, answer your questions, and guide you every step of the way.",
              ],
              [
                "No Hidden Fees",
                "No commissions or closing costs - what we offer is what you'll receive.",
              ],
              [
                "Discretion and Respect",
                "We value your privacy and handle every transaction with integrity.",
              ],
            ].map(([title, body]) => (
              <Accordion
                key={title}
                sx={(theme) => ({
                  backgroundColor:
                    theme.palette.mode === "dark"
                      ? theme.palette.primary.dark
                      : theme.palette.grey.A100,
                })}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography
                    fontFamily="latoBold"
                    sx={(theme) => ({
                      color:
                        theme.palette.mode === "dark"
                          ? theme.palette.common.white
                          : theme.palette.primary.main,
                    })}
                  >
                    {title}
                  </Typography>
                </AccordionSummary>

                <AccordionDetails>
                  <Typography
                    sx={(theme) => ({
                      color:
                        theme.palette.mode === "dark"
                          ? theme.palette.common.white
                          : theme.palette.primary.dark,
                    })}
                  >
                    {body}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </Box>
      </Box>

      <Box
        component="section"
        className="sell-my-home"
        sx={(theme) => ({
          backgroundColor:
            theme.palette.mode === "dark"
              ? theme.palette.secondary.main
              : theme.palette.primary.main,
          px: { xs: 3, md: 7 },
          py: 10,
          textAlign: "center",
        })}
      >
        <Typography
          sx={(theme) => ({
            color:
              theme.palette.mode === "dark"
                ? theme.palette.primary.main
                : theme.palette.common.white,
            fontSize: "2rem",
            fontFamily: "karla",
          })}
        >
          Ready to sell? Let us make you an offer today.
        </Typography>

        <Box sx={{ mt: "2.5em" }}>
          <Button
            variant="contained"
            color="warning"
            sx={{ px: "25px", py: "15px" }}
            onClick={() =>
              trackEvent("CTA", "Click", "Get Your Cash Offer Now")
            }
          >
            <Link className="link-item" to="/sell-my-home">
              <Typography
                sx={{
                  color: "common.white",
                  fontFamily: "latoBold",
                  fontSize: "1.15rem",
                }}
              >
                Get your Cash Offer Now
              </Typography>
            </Link>
          </Button>
        </Box>
      </Box>

      <Box className="content-wrapper">
        <Box component="section" className="contact-form">
          <Box mt={15} mb={10}>
            <Typography
              sx={(theme) => ({
                color:
                  theme.palette.mode === "dark"
                    ? theme.palette.common.white
                    : theme.palette.primary.main,
                fontSize: "2rem",
                fontFamily: "karla",
                mb: "0.5em",
                textAlign: "center",
              })}
            >
              Get Your Free, No-Obligation Cash Offer Today
            </Typography>

            <Form theme={props.theme} />
          </Box>

          <Box
            mt={15}
            sx={(theme) => ({
              backgroundColor:
                theme.palette.mode === "dark"
                  ? theme.palette.primary.light
                  : theme.palette.secondary.main,
              borderRadius: "25px 25px 0 0",
            })}
          >
            <Box className="contact-us-text-container">
              <Typography
                variant="h4"
                fontSize="2.25rem"
                fontFamily="karla"
                textAlign="center"
                sx={(theme) => ({
                  color:
                    theme.palette.mode === "dark"
                      ? theme.palette.warning.main
                      : theme.palette.primary.main,
                })}
              >
                Sell Your Indiana Home Fast with CarpHomes
              </Typography>

              <Typography
                lineHeight={2.5}
                mt={2}
                textAlign="center"
                sx={(theme) => ({
                  color:
                    theme.palette.mode === "dark"
                      ? theme.palette.common.white
                      : theme.palette.primary.dark,
                })}
              >
                We make selling your home easy, fast, and stress-free. As a
                local Indiana business, we offer cash purchases with no realtor
                commissions or closing costs. Close in as little as 7 days—no
                repairs, no open houses, no hassle. Enjoy a private,
                personalized experience with a team that understands your needs
                every step of the way.
              </Typography>

              <Box display="flex" justifyContent="center" mt={5}>
                <Button
                  variant="contained"
                  sx={(theme) => ({
                    backgroundColor:
                      theme.palette.mode === "dark"
                        ? theme.palette.warning.main
                        : theme.palette.primary.main,
                  })}
                  onClick={() => trackEvent("CTA", "Click", "Reach Out")}
                >
                  <Link className="link-item" to="/contact">
                    <Typography color="common.white">Reach Out</Typography>
                  </Link>
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      <Footer />
    </div>
  );
};

export default Splash;
